import type { OperationalLayerRow } from '../types'

export const SMART_SEARCH_NO_FOLDER_FACET = '__smart_search_no_folder__'

export function gisFolderLabelFromLayer(
  layer: OperationalLayerRow,
): string | null {
  const raw = layer.folder?.name
  const n = typeof raw === 'string' ? raw.trim() : ''
  return n.length > 0 ? n : null
}

export function folderFacetMatches(
  rowFolderLabel: string | null | undefined,
  facet: string | null,
): boolean {
  if (facet == null) return true
  if (facet === SMART_SEARCH_NO_FOLDER_FACET) {
    return !rowFolderLabel?.trim()
  }
  return rowFolderLabel?.toLowerCase() === facet.toLowerCase()
}
